/**
 * Normalize characters that look like markdown markers but use non-ASCII code points
 * (e.g. fullwidth asterisk from IME), so **bold** parses as GFM expects.
 */
export function normalizeMarkdownInput(s) {
  if (s == null || typeof s !== 'string') return '';
  return s
    .replace(/\uFF0A/g, '*') // FULLWIDTH ASTERISK ＊
    .replace(/\u2217/g, '*') // ASTERISK OPERATOR ∗
    .replace(/\uFE61/g, '*'); // SMALL ASTERISK ⁎
}
